const state={
  mapId:null,
  landAnalysis:null,
  layerName:null,
  projectId:null,//项目id
}
const mutations = {
  SET_MAPID(state, mapId){
    state.mapId = mapId;
  },  
  SET_LandAnalysis(state, landAnalysis){
    state.landAnalysis = landAnalysis;
  },
  SET_LAYERNAME(state, layerName){
    state.layerName = layerName;
  },
  SET_PROJECTID(state, projectId){
    state.projectId = projectId;
  },
}

const actions = {
  set_mapId({ commit }, data){
    commit('SET_MAPID', data)
  },
  set_LandAnalysis({ commit }, data){
    commit('SET_LandAnalysis', data)
  },
  set_layerName({ commit }, data){
    commit('SET_LAYERNAME', data)
  },
  set_projectId({ commit }, data){
    commit('SET_PROJECTID', data)
  },
}
export default {
  state,
  mutations,
  actions
}